import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaLinkedinIn, FaInstagram, FaTwitter, FaStar } from "react-icons/fa";
import "./footer.css";

const Footer = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    whileInView: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };
  return (
    <div>
      <footer className="footer-section">
        <Container>
          <Row className="gy-5">
            {/* Left */}

            <Col lg={5} md={12}>
              <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="whileInView"
                viewport={{ once: true }}
              >
                <img
                  src="./images/footer-logo.png"
                  alt="Logo"
                  className="footer-logo w-50"
                />

                <p className="footer-text">
                  Your trusted GCC Entry Gateway in GIFT City, providing an
                  integrated ecosystem for multinational corporations to
                  establish, operate and scale successfully.
                </p>
              </motion.div>
            </Col>

            {/* Quick Links */}

            <Col lg={2} md={4} sm={6}>
              <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="whileInView"
                viewport={{ once: true }}
              >
                <h5>Quick Links</h5>

                <ul>
                  <li>
                    <Link to="/">About Us</Link>
                  </li>
                  <li>
                    <Link to="/">Why GIFT City</Link>
                  </li>
                  <li>
                    <Link to="/">GCC Explorer</Link>
                  </li>
                  <li>
                    <Link to="/">Our Services</Link>
                  </li>
                  <li>
                    <Link to="/">Onboarding Process</Link>
                  </li>
                </ul>
              </motion.div>
            </Col>

            {/* Services */}

            <Col lg={3} md={4} sm={6}>
              <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="whileInView"
                viewport={{ once: true }}
              >
                <h5>Core Services</h5>

                <ul>
                  <li>
                    <Link to="/">GCC Establishment</Link>
                  </li>
                  <li>
                    <Link to="/">Legal & Regulatory</Link>
                  </li>
                  <li>
                    <Link to="/">Finance & Treasury</Link>
                  </li>
                  <li>
                    <Link to="/">Talent & HR Advisory</Link>
                  </li>
                  <li>
                    <Link to="/">Executive Relocation</Link>
                  </li>
                </ul>
              </motion.div>
            </Col>

            {/* Contact */}

            <Col lg={2} md={4}>
              <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="whileInView"
                viewport={{ once: true }}
              >
                <h5>Contact</h5>

                <p>GIFT City, Gandhinagar, Gujarat, India</p>

                <a
                  href="mailto:access@starlighttechlabs.com"
                  className="footer-mail"
                >
                  access@starlighttechlabs.com
                </a>

                <a href="tel:+919824018555" className="footer-phone">
                  +91 98240 18555
                </a>
                <div className="social-icons mt-3">
                  <a href="#">
                    <FaLinkedinIn />
                  </a>

                  <a href="#">
                    <FaTwitter />
                  </a>

                  <a href="#">
                    <FaInstagram />
                  </a>
                </div>
              </motion.div>
            </Col>
          </Row>

          <hr className="footer-divider" />

          <div className="footer-bottom">
            © 2026 GCC Giftcity. All Rights Reserved. Co-operating with IFSC
            Authorities.
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default Footer;
